@let isMobile = (breakpointObserverService.isMobile | async);
@let searchQuery = (menuSearchService.searchQuery$ | async);
@let activePreset = (menuPresetService.activePreset$ | async);

<div class="map-menu-container">
  <div class="groups-buttons-container" [ngStyle]="{'justify-content': !isMobile ? 'space-between' : ''}">
    <button
      *ngIf="!isMobile">
      {{ activeMenuGroup === MAPS_GROUP ? 'Maps' : ( activeMenuGroup === PLACES_GROUP ? 'Places' : (activeMenuGroup === ALL_DATA_GROUP ? 'All parameters' : 'Charts'))}}
    </button>

    <button class="switch-filters-menu-button"
            *ngIf="!isMobile"
            [ngClass]="isFiltersOpened ? 'filters-active' : ''"
            (click)="isFiltersOpened = !isFiltersOpened"
    >
      {{isFiltersOpened ? '—' : '＋'}}<span>{{isFiltersOpened ? 'Hide filters' : 'Filters' }}</span>
    </button>
  </div>

  <div class="mobile-menu-tabs" *ngIf="isMobile">
    <button [class.active]="activeMenuGroup === ALL_DATA_GROUP" (click)="activeMenuGroup = ALL_DATA_GROUP">All</button>
    <button [class.active]="activeMenuGroup === MAPS_GROUP" (click)="activeMenuGroup = MAPS_GROUP">Maps</button>
    <button [class.active]="activeMenuGroup === CHARTS_GROUP" (click)="activeMenuGroup = CHARTS_GROUP">Charts</button>
    <button [class.active]="activeMenuGroup === PLACES_GROUP" (click)="activeMenuGroup = PLACES_GROUP">Places</button>
  </div>

  <button class="groups-buttons-container-mobile"
    *ngIf="isMobile">
    {{ activeMenuGroup === MAPS_GROUP ? 'Maps' : ( activeMenuGroup === PLACES_GROUP ? 'Places' : (activeMenuGroup === ALL_DATA_GROUP ? 'All parameters' : 'Charts'))}}
  </button>

  <div class="menu-element-container">
    <app-menu-preset-chips
      *ngIf="!isMobile"
      [activePreset]="activePreset"
      (presetChange)="menuPresetService.setPreset($event)"
    ></app-menu-preset-chips>
    <app-filters-menu *ngIf="isFiltersOpened"></app-filters-menu>
    <app-menu-search></app-menu-search>

    <form [formGroup]="form">
      <ng-container *ngIf="(layersMenuService.groupsData | searchMenu:searchQuery!) as filteredGroups">

        <div *ngIf="filteredGroups.length === 0" class="no-search-result">
          No results found. Please try a different search query
        </div>

        <app-menu-group *ngFor="let groupData of layersMenuService.groupsData | searchMenu:searchQuery! | filterByPreset:activePreset; trackBy: identify"
                        [groupData]="groupData"
                        [activeMenuGroup]="activeMenuGroup"
                        [form]="form"
                        [isPaidPlan]="accessService.isPaidPlanActive | async"
                        class="map-menu-element"
                        [attr.data-cy]="groupData.e2eName"
                        [isFiltersOpened]="isFiltersOpened"
        ></app-menu-group>

        <app-upcoming-group
          *ngFor="let groupData of upcomingGroupsData; trackBy:identifyUpcoming"
          [upcomingGroupData]="groupData"
          [activeMenuGroup]="activeMenuGroup"
          class="map-menu-element"
        >

        </app-upcoming-group>
      </ng-container>
    </form>

  </div>
</div>
